import * as a from "three";
import { MainCamera as u } from "./components.js";
const M = 1e3, H = 5e4, P = 1e4, m = 16777215, w = {
  BOX: 0,
  SPHERE: 1
}, S = {
  PERSPECTIVE: 0,
  ORTHOGRAPHIC: 1
}, C = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map();
function g(e) {
  const t = d.get(e)?.canvas;
  let o = 16, s = 9;
  return t && t.clientWidth && t.clientHeight ? (o = t.clientWidth, s = t.clientHeight) : typeof window < "u" && (o = window.innerWidth, s = window.innerHeight), { width: o, height: s, aspect: o / s };
}
function I(e, n, t, o, s) {
  const { aspect: c } = g(n);
  let i;
  if (t === S.ORTHOGRAPHIC) {
    const r = s / 2, h = r * c;
    i = new a.OrthographicCamera(
      -h,
      h,
      r,
      -r,
      0.1,
      1e3
    );
  } else
    i = new a.PerspectiveCamera(o, c, 0.1, 1e3);
  return C.set(e, i), i;
}
function v(e, n, t) {
  const { aspect: o } = g(t);
  if (e instanceof a.OrthographicCamera) {
    const c = u.orthoSize[n] / 2, i = c * o;
    (e.top !== c || e.right !== i) && (e.left = -i, e.right = i, e.top = c, e.bottom = -c, e.updateProjectionMatrix());
  } else if (e instanceof a.PerspectiveCamera) {
    const s = u.fov[n];
    e.fov !== s && (e.fov = s, e.updateProjectionMatrix());
  }
}
function O(e, n) {
  const t = e.count;
  for (let o = 0; o < t; o++)
    if (e.getMatrixAt(o, n), n.elements[0] === 0 && n.elements[5] === 0 && n.elements[10] === 0)
      return o;
  return null;
}
function x(e, n, t = M) {
  const o = new a.InstancedMesh(e, n, t);
  o.instanceMatrix.setUsage(a.DynamicDrawUsage), o.castShadow = !0, o.receiveShadow = !0, o.frustumCulled = !1;
  const s = new a.Matrix4();
  s.makeScale(0, 0, 0);
  const c = new a.Color(m);
  for (let i = 0; i < t; i++)
    o.setMatrixAt(i, s), o.setColorAt(i, c);
  return o.instanceMatrix.needsUpdate = !0, o.instanceColor && (o.instanceColor.needsUpdate = !0), o;
}
function T(e, n, t, o) {
  const s = e.count, c = s * 2, i = x(n, t, c), r = new a.Matrix4(), h = new a.Color();
  for (let l = 0; l < s; l++)
    e.getMatrixAt(l, r), i.setMatrixAt(l, r), e.instanceColor && (e.getColorAt(l, h), i.setColorAt(l, h));
  return i.instanceMatrix.needsUpdate = !0, i.instanceColor && (i.instanceColor.needsUpdate = !0), o.remove(e), e.dispose(), o.add(i), i;
}
const d = /* @__PURE__ */ new WeakMap();
function A() {
  const e = /* @__PURE__ */ new Map();
  return e.set(w.BOX, new a.BoxGeometry()), e.set(w.SPHERE, new a.SphereGeometry(1)), e;
}
function R() {
  const e = new a.Scene(), n = new a.HemisphereLight(11657727, 12155424, 1.5);
  e.add(n);
  const t = new a.DirectionalLight(16777215, 2.5);
  return t.castShadow = !0, t.shadow.mapSize.width = 4096, t.shadow.mapSize.height = 4096, e.add(t), e.add(t.target), {
    scene: e,
    meshPools: /* @__PURE__ */ new Map(),
    unlitMeshPools: /* @__PURE__ */ new Map(),
    geometries: A(),
    material: new a.MeshStandardMaterial({
      metalness: 0,
      roughness: 1
    }),
    unlitMaterial: new a.MeshBasicMaterial(),
    entityInstances: /* @__PURE__ */ new Map(),
    lights: {
      ambient: n,
      directional: t
    },
    totalInstanceCount: 0,
    hasShownPerformanceWarning: !1
  };
}
function p(e) {
  let n = d.get(e);
  return n || (n = R(), d.set(e, n)), n;
}
function W(e) {
  return d.get(e)?.scene || null;
}
function N(e, n) {
  f.set(e, n);
}
function z(e) {
  return f.get(e);
}
function L(e) {
  f.delete(e);
}
function _(e, n) {
  const t = p(e);
  t.canvas = n;
}
function G(e, n) {
  const t = new a.WebGLRenderer({
    canvas: e,
    antialias: !0
  }), o = e.clientWidth || window.innerWidth, s = e.clientHeight || window.innerHeight;
  return t.setSize(o, s, !1), t.setPixelRatio(window.devicePixelRatio), t.shadowMap.enabled = !0, t.shadowMap.type = a.PCFSoftShadowMap, n !== 0 && t.setClearColor(n), t;
}
function D(e, n) {
  const o = p(e).canvas, s = o?.clientWidth || window.innerWidth, c = o?.clientHeight || window.innerHeight, i = s / c;
  n.setSize(s, c, !1);
  for (const [, r] of C)
    if (r instanceof a.PerspectiveCamera)
      r.aspect = i, r.updateProjectionMatrix();
    else if (r instanceof a.OrthographicCamera) {
      const l = (r.top - r.bottom) / 2 * i;
      r.left = -l, r.right = l, r.updateProjectionMatrix();
    }
}
const U = {
  LIGHT_DIRECTION: new a.Vector3(5, 10, 2).normalize(),
  LIGHT_DISTANCE: 25,
  CAMERA_RADIUS: 50,
  NEAR_PLANE: 1,
  FAR_PLANE: 200
};
export {
  S as CameraProjection,
  H as MAX_TOTAL_INSTANCES,
  P as PERFORMANCE_WARNING_THRESHOLD,
  w as RendererShape,
  U as SHADOW_CONFIG,
  A as createGeometries,
  G as createRenderer,
  I as createThreeCamera,
  L as deleteCanvasElement,
  O as findAvailableInstanceSlot,
  g as getCanvasAspect,
  z as getCanvasElement,
  p as getRenderingContext,
  W as getScene,
  D as handleWindowResize,
  R as initializeContext,
  x as initializeInstancedMesh,
  T as resizeInstancedMesh,
  N as setCanvasElement,
  _ as setRenderingCanvas,
  v as syncCameraSettings,
  C as threeCameras
};
//# sourceMappingURL=utils.js.map
